// filepath: /Users/george/MatrizInc/MarketBrewer/Clients/street-lawyer-services/website/src/core/Blogs/template/LocalSEOTemplate/BlogSidebar/CTA.tsx
import React from "react";
import { Link } from "react-router-dom";

const CTASection: React.FC = () => {
  return (
    <div className="bg-gradient-to-br from-cannabis-green-900 to-law-black-700 rounded-xl shadow-md p-4 sidebar-item border border-cannabis-green-500/20">
      <div className="flex justify-between items-center">
        <Link
          to="/locations"
          className="text-center bg-white text-cannabis-green-800 px-3 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors flex-grow shadow-md flex justify-center items-center text-sm"
        >
          <svg
            className="w-4 h-4 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            />
          </svg>
          Locations
        </Link>
        <span className="px-2 text-white/80">or</span>
        <Link
          to="/contact"
          className="text-center bg-cannabis-green-700 text-white px-3 py-2 rounded-lg font-medium hover:bg-cannabis-green-600 transition-colors flex-grow shadow-md flex justify-center items-center text-sm"
        >
          <svg
            className="w-4 h-4 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          Contact
        </Link>
      </div>
    </div>
  );
};

export default CTASection;
